// Figma "cases" > Bol.com, section 55:1458, frames 55:1459 (cover), 55:1496, 55:1521, 55:1546, 55:1571, 55:1596, 55:1621
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/bol/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const BOL = own

export const bol: Case = {
    name: "Bol.com",
    theme: {
        page: "#00004d",
        gradient: "linear-gradient(180deg, #00004d 0%, #00009a 100%)",
        stops: [
            [0, 0, 77, 0],
            [0, 0, 154, 1],
        ],
        fill: "#0000a9",
        line: "#8fcdfc",
        tone: "dark",
        title: "#ffffff",
        body: "rgba(255, 255, 255, 0.6)",
    },
    modules: [
        {
            type: "grid",
            columns: [
                {
                    w: 220,
                    cells: [
                        {
                            h: 220,
                            tag: { logo: "/work/bol/logo.svg", logoBox: [20, 24, 69, 27], text: "BOL.COM\nONLINE WINKEL\n\nAPP" },
                        },
                        { h: 626 },
                    ],
                },
                {
                    w: 443,
                    cells: [
                        { h: 443, image: BOL("1-1", 884, 886), phone: false },
                        {
                            h: 400,
                            grow: true,
                            card: {
                                title: "Bringing the book to life",
                                body: "This app is an extension of a toy bible from Bol.com. It allows children to discover each world by augmenting the content displayed in the book. Designed and conceived together with Leon van Zijl, Franklin Schamhart, Nienke van Kuijk among others.",
                            },
                        },
                    ],
                },
                {
                    w: 888,
                    cells: [
                        // (the quiz animation on top, the book under it)
                        { h: 233, w: 521, last: true, keep: true, image: { id: "/work/bol/c-confetti", src: "/work/bol/c-confetti", w: 1042, h: 466, widths: [800, 1042] }, clip: { src: "/work/bol/c-confetti" } }, // video: node 55:1495 ("confetti 1"), pink Mario quiz card ("Quiz / Wie is de beste vriend van Mario?")
                        { h: 610, image: BOL("1-2", 1776, 1220), phone: false },
                    ],
                },
            ],
        },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: BOL("2-1", 3114, 1692) }] }] },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: BOL("3-1", 3114, 1692) }] }] },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: BOL("4-1", 3114, 1692) }] }] },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: BOL("5-1", 3114, 1692) }] }] },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: BOL("6-1", 3114, 1692) }] }] },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: BOL("7-1", 3114, 1692) }] }] },
    ],
}
